import {
  useRef,
} from 'react';

import {
  Icon,
  Popup,
  Tooltip,
  TextInput,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';
import * as ParentS from '../../styled';

type Props = {
  isOpen: boolean
  setIsOpen: { (isOpen: boolean): void },
  onInsert: { (url: string): void }
};

const LinkStyle = ({
  isOpen,
  setIsOpen,
  onInsert,
}: Props) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const onSubmit = () => {
    const url = inputRef.current?.value?.trim()
    if (url) onInsert(url)
    setIsOpen(false)
  }

  return (
    <Popup
      isOpen={isOpen}
      trigger={(
        <Flex>
          <Tooltip body="Insert Link" positions={['top']} >
            <ParentS.Control>
              <Icon type="fas fa-link" />
            </ParentS.Control>
          </Tooltip>
        </Flex>
      )}
      setPopupVisible={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(!isOpen);
      }}
      onClickOutside={() => setIsOpen(false)}
    >
      <S.Dropdown
        onMouseDown={(e) => {
          // e.preventDefault();
          e.stopPropagation();
          // onToggle(type.style);
        }}
      >
        <Flex
          align="center"
          padding="10px 20px 5px 20px"
          spacing={10}
        >
          <TextInput
            inputRef={inputRef}
            height="2rem"
            padding="2px 8px"
            onKeyDown={(e: any) => {
              if (e.key === 'Enter') {
                onSubmit()
              }
            }}
          />
          <Flex
            clickable
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onSubmit()
              setIsOpen(false);
            }}
          >
            <S.PlusCircle />
          </Flex>
        </Flex>
      </S.Dropdown>
    </Popup>
  );
};

export default LinkStyle;
